import { default as completeO667VtM4OsMeta } from "/home/mycrashbaggage/webapps/mycrashbaggage/pages/complete.vue?macro=true";
import { default as indexKeLoXvWEUCMeta } from "/home/mycrashbaggage/webapps/mycrashbaggage/pages/index.vue?macro=true";
import { default as maintenancebuh83aFeQWMeta } from "/home/mycrashbaggage/webapps/mycrashbaggage/pages/maintenance.vue?macro=true";
import { default as newsletterk3shXwFD1LMeta } from "/home/mycrashbaggage/webapps/mycrashbaggage/pages/newsletter.vue?macro=true";
import { default as productGNfFwBidOMMeta } from "/home/mycrashbaggage/webapps/mycrashbaggage/pages/product.vue?macro=true";
import { default as registermNSTpfcTMSMeta } from "/home/mycrashbaggage/webapps/mycrashbaggage/pages/register.vue?macro=true";
import { default as serial_45number4zvCYX1LIDMeta } from "/home/mycrashbaggage/webapps/mycrashbaggage/pages/serial-number.vue?macro=true";
export default [
  {
    name: "complete",
    path: "/complete",
    component: () => import("/home/mycrashbaggage/webapps/mycrashbaggage/pages/complete.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/mycrashbaggage/webapps/mycrashbaggage/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/home/mycrashbaggage/webapps/mycrashbaggage/pages/maintenance.vue").then(m => m.default || m)
  },
  {
    name: "newsletter",
    path: "/newsletter",
    component: () => import("/home/mycrashbaggage/webapps/mycrashbaggage/pages/newsletter.vue").then(m => m.default || m)
  },
  {
    name: "product",
    path: "/product",
    component: () => import("/home/mycrashbaggage/webapps/mycrashbaggage/pages/product.vue").then(m => m.default || m)
  },
  {
    name: "register",
    path: "/register",
    component: () => import("/home/mycrashbaggage/webapps/mycrashbaggage/pages/register.vue").then(m => m.default || m)
  },
  {
    name: "serial-number",
    path: "/serial-number",
    component: () => import("/home/mycrashbaggage/webapps/mycrashbaggage/pages/serial-number.vue").then(m => m.default || m)
  }
]